<div class="fui-heading-container">
  <fui-heading [text]="'profile.edit.addresses' | translate" [level]="5"></fui-heading>
  <button class="fui-action-btn" (click)="addAddress()">
    <fa-icon icon="plus"></fa-icon>
    {{ "account.add_address" | translate }}
  </button>
</div>

@if (loading) {
  <myp-skeleton-loader type="list-item" [number]="5" extraContainerClass="m-y-20"></myp-skeleton-loader>
}
@if (!loading && !addresses?.length) {
  <div class="m-t-20 text-muted">No addresses to display.</div>
}
@if (!loading && addresses?.length) {
  <div class="m-t-20">
    @for (address of addresses; track address) {
      <myp-list-item
        [title]="address.name + ' ' + address.address1 + ' ' + address.formattedArea"
        [metadata]="[
          {
            title: 'Phone',
            value: address.phone,
          },
          {
            title: address.default ? 'Default' : '',
            value: '',
          },
        ]"
        [showImage]="false"
        [includeChevron]="false"
      >
        <div class="button-content">
          <fa-icon icon="pencil" class="action circle-icon-btn" ngbTooltip="Edit Address" tabindex="0" (keyup.enter)="editAddress(address)" (click)="editAddress(address)"></fa-icon>
          <fa-icon icon="times" class="action circle-icon-btn" ngbTooltip="Delete Address" tabindex="0" (keyup.enter)="deleteAddress(address)" (click)="deleteAddress(address)"></fa-icon>
          @if (editingAddresses[address.id]) {
            <fa-icon icon="spinner" animation="spin" class="action circle-icon-btn"></fa-icon>
          }
        </div>
      </myp-list-item>
    }
  </div>
}
